var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import TabControlled from "./TabControlled.js";
var TabUncontrolled = function (props) {
    var defaultActiveTabId = props.defaultActiveTabId, onTabChange = props.onTabChange;
    var _a = React.useState(defaultActiveTabId), activeTabId = _a[0], setActiveTabId = _a[1];
    var handleTabChange = function (id) {
        // The onTabChange callback gets suppressed in the case when there is no activeTabId provided by default
        var silent = false;
        if (!activeTabId)
            silent = true;
        setActiveTabId(id);
        if (onTabChange && !silent)
            onTabChange(id);
    };
    return (React.createElement(TabControlled, __assign({}, props, { activeTabId: activeTabId, defaultActiveTabId: undefined, onTabChange: handleTabChange })));
};
export default TabUncontrolled;
